import { Link, useLocation } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta(
    "页面不存在 - 国产在线观看",
    "你访问的页面不存在，返回国产在线观看继续浏览高清国产电影、电视剧与综艺节目资源。"
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <header className="border-b border-background-200 bg-background-50">
        <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-fill text-xl" aria-hidden="true" />
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">国产在线观看</span>
          </Link>
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-16">
        <div className="w-full max-w-2xl rounded-lg border border-background-200 bg-background-50 p-8 text-center md:p-12">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 text-primary-950">
            <i className="ri-ghost-2-line text-3xl" aria-hidden="true" />
          </span>
          <h1 className="mt-5 font-heading text-4xl font-black text-foreground-950 md:text-5xl">404</h1>
          <p className="mt-3 font-heading text-lg font-bold text-foreground-900">
            页面走丢了
          </p>
          <p className="mt-2 text-sm text-foreground-600">
            你访问的页面不存在或已被移除，错误路径：
          </p>
          <p className="mt-1 break-all rounded-md bg-background-100 px-3 py-2 font-mono text-xs text-foreground-600">
            {location.pathname}
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line text-base" aria-hidden="true" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-search-line text-base" aria-hidden="true" />
              去搜索影视
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}